<template>
  <div>
    <div id="card">
      <!-- 會員卡 -->
      <div class="usercard">
        <el-row>
          <div style="text-align: left; padding-left: 17px; margin-top: 7px;">
            <el-radio-group v-model="codetype" fill="#666">
              <el-radio-button label="qr">{{ $t('Member.qrcode') }}</el-radio-button>
              <el-radio-button label="bar">{{ $t('Member.barcode') }}</el-radio-button>
              <el-radio-button label="invoice" v-if="invoice">{{ $t('Member.invoice') }}</el-radio-button>
            </el-radio-group>
          </div><br/>
          <el-col :span="24" v-if="codetype === 'qr'">
            <div style="text-align: center; padding: 15px; border: 1px solid #eee; width: 90%; margin: 0 auto;">
              <qrcode-vue :value="qrCode" size="115" level="H"></qrcode-vue>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" v-if="codetype === 'bar'">
            <div style="text-align: center; padding: 15px; border: 1px solid #eee; width: 90%; margin: 0 auto;">
              <img :src="barCode" width="100%"/>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" v-if="codetype === 'invoice'">
            <div style="text-align: center; padding: 15px; border: 1px solid #eee; width: 90%; margin: 0 auto;">
              {{ $t('Member.not_open') }}
            </div>
          </el-col>
        </el-row>
        <div style="position: absolute; right: 20px; bottom: 10px;">
          <el-button @click="refreshData">刷新<i class="el-icon-refresh el-icon--right"></i></el-button>
        </div>
        <div style="margin-top: 15px; font-size: 13px; text-align: left; padding-left: 20px; width: 55%;" v-if="number !== 0 && codetype === 'qr'">{{ $t('Member.invalid_code1') }} {{ number }} {{ $t('Member.invalid_code2') }}</div>
        <div style="margin-top: 15px; font-size: 13px; text-align: left; padding-left: 20px; color: #f24; width: 55%;" v-if="number === 0 && codetype === 'qr'">{{ $t('Member.invalid_code3') }}</div>
        <div style="margin-top: 15px; font-size: 13px; text-align: left; padding-left: 20px; width: 55%;" v-if="number !== 0 && codetype === 'bar'">{{ $t('Member.invalid_code4') }} {{ number }} {{ $t('Member.invalid_code2') }}</div>
        <div style="margin-top: 15px; font-size: 13px; text-align: left; padding-left: 20px; color: #f24; width: 5%;" v-if="number === 0 && codetype === 'bar'">{{ $t('Member.invalid_code5') }}</div>
        <div style="position: absolute; left: 20px; bottom: 15px;" v-if="showBtn">
          <el-button type="danger" @click="pointDia = true" size="small">如何獲得點數?</el-button>
        </div>
        <mu-dialog title="獲得點數方式" :open="pointDia" width="80%" @close="pointDia = false">
          推薦好友加入會員，並且請他註冊時候在推薦碼填上您註冊的電話號碼，每推薦一個您和被推薦人都可以獲得點數，有任何問題可以 <a :href="customLink" target="blank">詢問LINE@客服</a>。<br><br>
          也可以傳送推薦連結給好友
          <mu-button slot="actions" color="primary" @click="doCopy">複製推薦連結</mu-button>
          <FlashMessage></FlashMessage>
        </mu-dialog>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import QrcodeVue from 'qrcode.vue';
import VueBarcode from 'vue-barcode';
import { mapGetters, mapActions } from 'vuex';

export default {
  data() {
    return {
      num: null,
      points: 0,
      username: '無資料',
      id: localStorage.getItem('nowLoginUser'),
      auth: this.$route.params.auth,
      service: this.$route.params.service,
      tableData: [],
      codetype: 'qr',
      number: 180,
      pointDia: false
    };
  },
  mounted() {
    if (this.customLink && this.memberUrl) {
      this.showBtn = true;
    }
    this.counting();
    this.getPoint();
  },
  props: ['qrCode', 'barCode', 'userName', 'logo', 'invoice', 'only', 'customLink', 'memberUrl', 'showBtn'],
  components: {
    VueBarcode,
    QrcodeVue
  },
  computed: {
    ...mapGetters({
      consumeList: 'consumeList',
      userpoints: 'userpoints'
    }),
    options() {
      return {
        format: "pharmacode",
        lineColor: "#0aa",
        width: 4,
        height: 40,
        displayValue: false
      };
    },
  },
  methods: {
    ...mapActions({
      checkUserFB: 'checkUserFB',
      checkUserLINE: 'checkUserLINE',
      getDetail: 'getDetail'
    }),
    col() {
      if (!this.logo || this.only) {
        return 24;
      }
      return 12;
    },
    doCopy() {
      this.$copyText(this.memberUrl);
      this.flashMessage.success({
        title: `Copied: ${this.memberUrl}`,
        time: 2000
      });
    },
    counting() {
      setInterval(() => {
        if (this.number > 0) {
          this.number -= 1;
        }
      }, 1000);
    },
    getPoint() {
      if (this.service === 'LINE') {
        this.checkUserLINE({ ChannelID: this.auth, UserID: this.id });
      }
      else {
        this.checkUserFB({ PageID: this.auth, PSID: this.id });
      }
    },
    OfficialSite() {
      window.open('https://www.eilis-ai.com/');
    },
    show(val) {
      this.num = val;
    },
    refreshData() {
      window.location.reload();
    }
  },
}
</script>

<style scoped>
  .hint {
    position: absolute;
    right: 5px;
    bottom: 5px;
    color: black;
    opacity: 0.8;
    font-size: 13px;
  }
  .web {
    text-decoration: none;
    color: #888;
    transition: 0.2s;
    font-size: 13px;
  }
  .usercard {
    height: 300px;
    position: relative;
    border-radius: 5px;
    padding-top: 15px;
    margin: 10px auto;
    width: 90%;
    background-color: #fff;
    box-shadow: 1px 1px 1px 1px rgba(20%, 20%, 20%, 0.2);
  }
  .reload {
    position: absolute;
    right: 5px;
    bottom: 20px;
  }
  #card {
    width: 100%;
    /* height: 600px; */
    max-width: 550px;
    margin: -5px auto;
    overflow: hidden;
    border-radius: 5px;
  }
  .el-menu-demo {
    text-align: center !important;
  }
</style>
